export const iconFontAwesomeMapsBridge = (
	<i className="fa-solid fa-bridge"></i>
);
